export default "__VITE_ASSET__B8Vh4pkd__"